import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef, forwardRef } from '@angular/core';

import { NzMessageService } from 'ng-zorro-antd/message';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorDO } from '../../../BaseFramework/shared/models/error.model';
import * as flat from 'flat'
import * as dict from 'spelling/dictionaries/en_US.js'
import * as spelling from 'spelling/'

import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  InteractService,
  ComponentOutputDO,
  AppMetadataHandler
} from 'app'
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import * as moment from 'moment/moment';
import { map, delay, take } from 'rxjs/operators';
import { of, Observable } from 'rxjs';
import { MetadataService } from 'app/BaseFramework/core/http/metadata.service';
import { TechnicalTranslatePipe } from 'app/BaseFramework/shared/custom-pipes';
import { CustomHookService } from 'app/ViewModules/shared-services/custom-hook/custom-hook.service';

class ClaimBillDetailsDO {
  billNum: string
  billDate: Date
  billType: string
  providerId: string
  billAmount: string
  billStatus: string
  approvedAmount: string
  allowedAmount: string
  claimEstimatedBillBreakups: Array<any> = []
}

class ClaimBillBreakUpDO {
  billItemCd: string
  billItemQuantity: Number
  billRate: string
  billAmount: string
  approvedAmount: string
  allowedAmount: string
  remarks: string
  reason: string
  itemStatus: string
  benefitTypeCd: string
}

interface ValidationOutput {
  isInvalid: boolean,
  errorDOs: Array<ErrorDO>
}

class SearchAPIMetaDataDO {
  key: any;
  keyDescription: any;
  valueInputType: any;
  lookupName: any;
  lookup: any;
  enable: any;
  isMandatory: Boolean;
}

@Component({
  selector: 'app-input-grid-nested',
  templateUrl: './input-grid-nested.component.html',
  styleUrls: ['./input-grid-nested.component.scss'],
  providers: [TechnicalTranslatePipe,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputGridNestedComponent),
      multi: true
    }]
})
export class InputGridNestedComponent implements OnInit, ControlValueAccessor {
  baseComponentName = 'InputGridNestedComponent'
  _currentComponentName = 'InputGridNestedComponent';
  exampleConfigModal = false;
  exampleConfig = {
    "gridConfig": {
      "parentGridTitle": "Tariff",
      "fieldKey": "tariffs",
      "fieldMapping": "providerDO-hospital-tariffs",
      "parentFormArray": "tariffFormArray",
      "canAdd": true,
      "parentRowFormMetaData": [
        {
          "fieldName": "Id",
          "fieldKey": "id",
          "fieldType": "INPUT",
          "lookupCd": null
        },
        {
          "fieldName": "GUID",
          "fieldKey": "guid",
          "fieldType": "INPUT",
          "lookupCd": null
        },
        {
          "fieldName": "Type",
          "fieldKey": "typeCd",
          "fieldType": "COMBO",
          "lookupCd": "tariffTypeCd",
          "sortOrder": 2,
          "visibility": true,
          "width": "140px"
        },
        {
          "fieldName": "Provider Name",
          "fieldKey": "name",
          "fieldType": "INPUT",
          "lookupCd": null,
          "sortOrder": 0,
          "visibility": true,
          "width": "140px"
        },
        {
          "fieldName": "Status",
          "fieldKey": "status",
          "fieldType": "COMBO",
          "lookupCd": "tariffStatusCd",
          "sortOrder": 1,
          "visibility": true,
          "width": "140px"
        },
        {
          "fieldName": "Valid From",
          "fieldKey": "validFrom",
          "fieldType": "DATE",
          "ignoreDateTimeConversion": true,
          "lookupCd": null,
          "sortOrder": 2,
          "visibility": true,
          "width": "100px"
        },
        {
          "fieldName": "Valid to",
          "fieldKey": "validTo",
          "fieldType": "DATE",
          "ignoreDateTimeConversion": true,
          "lookupCd": null,
          "sortOrder": 2,
          "visibility": true,
          "width": "100px"
        },
        {
          "fieldName": "Provider ID",
          "fieldKey": "providerId",
          "fieldType": "CUSTOM",
          "customTemplateName": "providerIDSearchAndLink",
          "lookupCd": null,
          "sortOrder": 3,
          "visibility": false,
          "width": "140px"
        },
        {
          "fieldName": "Tariff Details",
          "fieldKey": "tariffDetails",
          "fieldType": "FORMARRAY",
          "isChildGrid": true,
          "childGridTitle": "Tariff Details",
          "canAdd": true,
          "childGridMetaData": [
            {
              "fieldName": "Id",
              "fieldKey": "id",
              "fieldType": "INPUT",
              "lookupCd": null,
              "visibility": false,
              "width": "140px"
            },
            {
              "fieldName": "GUID",
              "fieldKey": "guid",
              "fieldType": "INPUT",
              "lookupCd": null,
              "visibility": false,
              "width": "140px"
            },
            {
              "fieldName": "Item",
              "fieldKey": "itemCd",
              "fieldType": "COMBO",
              "lookupCd": "healthClaimBillItemsCd",
              "comboMode": 'multiple',
              "comboBinding": 'CSV',
              "sortOrder": 0,
              "visibility": true,
              "width": "140px",
              "fieldRules": [
                {
                  "methodName": "getSubItemList",
                  "methodParameters": [
                    "itemCd"
                  ],
                  "extractAttributeMapping": "billItemDOList",
                  "targetFieldKey": "subItemCd",
                  "targetAttributeType": "replaceLookupValueList",
                  "lookupKeyVariable": "billSubItemCd",
                  "lookupValueVariable": "billSubItemDesc"
                }
              ]
            },
            {
              "fieldName": "Sub Item",
              "fieldKey": "subItemCd",
              "fieldType": "COMBO",
              "lookupCd": "healthClaimBillSubItemsCd",
              "sortOrder": 1,
              "visibility": true,
              "width": "140px"
            },
            {
              "fieldName": "Rate Type",
              "fieldKey": "rateTypeCd",
              "fieldType": "COMBO",
              "lookupCd": "billItemDisbursementTypeCd",
              "lookupValues": [],
              "sortOrder": 2,
              "visibility": true,
              "width": "140px"
            },
            {
              "fieldName": "Room Type",
              "fieldKey": "roomTypeCd",
              "fieldType": "COMBO",
              "lookupCd": "RoomTypeCd",
              "sortOrder": 3,
              "visibility": true,
              "width": "140px"
            },
            {
              "fieldName": "Quantity",
              "fieldKey": "quantity",
              "fieldType": "INPUT",
              "lookupCd": null,
              "sortOrder": 4,
              "visibility": true,
              "width": "140px"
            },
            {
              "fieldName": "Rate",
              "fieldKey": "rate",
              "fieldType": "CURRENCYINPUT",
              "lookupCd": null,
              "sortOrder": 5,
              "visibility": true,
              "width": "140px"
            },
            {
              "fieldName": "Remarks",
              "fieldKey": "remarks",
              "fieldType": "TEXTAREA",
              "lookupCd": null,
              "maxlength": 500,
              "sortOrder": 6,
              "visibility": true,
              "width": "140px"
            },
            {
              "fieldName": "Is Excluded?",
              "fieldKey": "exclusionFl",
              "fieldType": "CHECKBOX",
              "lookupCd": null,
              "sortOrder": 7,
              "visibility": true,
              "width": "140px"
            }
          ],
          "lookupCd": null,
          "sortOrder": 0
        }
      ]
    },
    "isDisabled": null
  }
  supportedTargetAttributeTypes = ["pushLookupValueList", "replaceLookupValueList", "value", "lookupCd", "metaDataAttribute"]
  /**
    * 
    * ControlValueAccessor Implementation
    */
  writeValue(obj: any): void {
    if (obj !== undefined) {
      // MainList = obj;
    }
  }
  propagateChange = (_: any) => { };

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any): void {
  }
  setDisabledState?(isDisabled: boolean): void { }
  constructor(private viewContainerRef: ViewContainerRef,
    private validationUtilService: ValidationUtilService,
    public apiRequestService: ApiRequestService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private commonUtilty: CommonUtilty,
    private i18nService: I18nService,
    private multiLingualService: MultiLingualService,
    private translateService: TranslateService,
    private lookupDataService: LookupDataService,
    private interactService: InteractService,
    public appMetadataHandler: AppMetadataHandler,
    public metadataService: MetadataService,
    public msg: NzMessageService,
    private technicalTranslatePipe: TechnicalTranslatePipe,
    private customHookService: CustomHookService) {
  }

  //Declarations which might need developer input
  exclusionForm: FormGroup
  FORMNAME = "billDetails"
  lookupsToBind = []
  selectorOfThisComponent = 'app-input-grid-nested'
  parentEvent$
  exclusionList: Array<any> = [];
  environment = environment
  currencyOptions = {
    prefix: this.appMetadataHandler.baseCurrencyPREFIX,
    thousands: this.appMetadataHandler.THOUSANDS_SEPARATOR,
    decimal: this.appMetadataHandler.DECIMAL_SEPARATOR
  }

  BillTableVisibilityConfig = {
    "healthClaimRegistration": {
      BillApprovedAmount: false,
      BillDisallowedAmount: false,
      BillDisallowedReason: false,
      BillBreakupApprovedAmount: false,
      BillBreakupDisallowedAmount: false,
      BillBreakupDisallowedReason: false
    },
    "providerRegistration-hospital": {
      BillApprovedAmount: true,
      BillDisallowedAmount: true,
      BillDisallowedReason: true,
      BillBreakupApprovedAmount: true,
      BillBreakupDisallowedAmount: true,
      BillBreakupDisallowedReason: true
    },
    "healthClaimPayout": {
      BillApprovedAmount: true,
      BillDisallowedAmount: true,
      BillDisallowedReason: true,
      BillBreakupApprovedAmount: true,
      BillBreakupDisallowedAmount: true,
      BillBreakupDisallowedReason: true
    }
  }

  @Output() componentOutput = new EventEmitter<any>();
  @Input() type: string;
  @Input() transactionState: string;
  @Input()
  set currentComponent(value) {
    if (value) this._currentComponentName = value
  }
  get currentComponent() {
    return this._currentComponentName
  }

  @Input() maxDepth
  private _extractElementFromArray
  @Input()
  set ExtractElementFromArray(value) {
    this._extractElementFromArray = value
  }
  get ExtractElementFromArray() {
    return this._extractElementFromArray
  }
  get flatteningSafetyValue() {
    if (this._extractElementFromArray) {
      return 'unsafe'
    }
    else {
      return 'safe'
    }
  }

  masterConfig: any = null
  parentFormArrayName: any = "gridForm"

  @Input()
  set componentMetaData(value) {
    if (value) {
      //gridConfig
      let extractedConfig = value.gridConfig ? this.commonUtilty.deepCopy(value.gridConfig) : this.commonUtilty.deepCopy(value)
      //parentGridTitle
      extractedConfig = this.attributeMapper(extractedConfig, 'parentGridTitle', 'heading');
      //parentRowFormMetaData
      extractedConfig = this.attributeMapper(extractedConfig, 'parentRowFormMetaData', 'columns');
      //canAdd
      extractedConfig = this.attributeMapper(extractedConfig, 'canAdd', 'enableAddRemoveRows');
      //parentFormArray
      extractedConfig['parentFormArray'] = this.parentFormArrayName
      //Final Config assigned
      this.masterConfig = this.commonUtilty.deepCopy(extractedConfig)
    }
    else {
      console.warn(`Metadata Missing for ${this.getCurrentComponentName()}`)
    }
  }

  private attributeMapper(extractedConfig: any, sourceAttr, targetAttr) {
    if (extractedConfig[sourceAttr])
      extractedConfig[targetAttr] = extractedConfig[sourceAttr];
    else if (extractedConfig[targetAttr])
      extractedConfig[sourceAttr] = extractedConfig[targetAttr];
    return extractedConfig
  }

  get componentMetaData() {
    return this.masterConfig
  }

  private _inputDataForEdit = null;
  private _initialPayload
  @Input()
  set IO(value: any) {
    if (value) {
      this._inputDataForEdit = this.ServerToUITransform(value, this.componentMetaData);
      this._initialPayload = this.commonUtilty.deepCopy(value)
    }
  };

  @Input()
  set inputDataForEdit(value: any) {
    if (value) {
      this._inputDataForEdit = value;
    }
  };

  get inputDataForEdit() {
    return this._inputDataForEdit
  }

  EmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput, this.UItoServerTransform)
  }
  getParentComponent(): Component {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
      
    } catch (error) {
      
    }
  }
  getParentComponentName(): string {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
      
    } catch (error) {
      
    }
  }
  getCurrentComponentName(): string {
    return this._currentComponentName
  }

  subscribeToParentEvent() {
    if (this.parentEvent$ != null)
      this.parentEvent$.unsubscribe()
    this.parentEvent$ = this.interactService.pingSubject$.subscribe((param: any) => {
      const matches = param.filter(s => s.includes(this.getCurrentComponentName()));
      if (this.commonUtilty.isArrayIterable(param) && this.commonUtilty.isArrayIterable(matches)) {
        let validationResult = this.validateOutput(this.parentGridForm, this.masterConfig.parentRowFormMetaData)
        if (!validationResult.isInvalid) {
          let extractData = this.checkEmptyRows(this.parentGridForm)
          let output = { metaData: this.componentMetaData, data: extractData }
          this.EmitComponentOutput(output)
        }
        else {
          this.EmitComponentOutput(validationResult)
        }
      }
      else {
        console.warn(`${this.getCurrentComponentName()} received the ping, but is not a emitter child for current transaction type.`)
      }
    })
  }



  UItoServerTransform(payload, response) {
    let DO = this.commonUtilty.getDOName(payload)
    let flattenedIO = this.commonUtilty.plainflattenObject(payload, this.flatteningSafetyValue, this.maxDepth)
    let metaData = response.componentData.metaData
    if (payload && payload[DO] && flattenedIO && metaData.fieldMapping) {
      flattenedIO[metaData.fieldMapping] = this.commonUtilty.deepCopy(response.componentData.data)
    }

    /**
     * Datatype wise manipulations
     */
    let fieldKeyWiseParentRowMetaData = this.commonUtilty.convertArrayToMap(metaData.parentRowFormMetaData, 'fieldKey')
    let dataTypeWiseParentRowMetaData = this.commonUtilty.convertArrayToMap(metaData.parentRowFormMetaData, 'fieldType')
    let fieldKeyWiseChildRowMetaData = dataTypeWiseParentRowMetaData['FORMARRAY'] && this.commonUtilty.isArrayIterable(dataTypeWiseParentRowMetaData['FORMARRAY']['childGridMetaData']) ? this.commonUtilty.convertArrayToMap(dataTypeWiseParentRowMetaData['FORMARRAY']['childGridMetaData'], 'fieldKey') : []
    if (this.commonUtilty.isArrayIterable(flattenedIO[metaData.fieldMapping])) {
      flattenedIO[metaData.fieldMapping].forEach((parentRow, parentIndex) => {
        for (const parentRowFieldKey in parentRow) {
          if (fieldKeyWiseParentRowMetaData[parentRowFieldKey]) {
            if (fieldKeyWiseParentRowMetaData[parentRowFieldKey].fieldType == 'DATE' && !fieldKeyWiseParentRowMetaData[parentRowFieldKey].ignoreDateTimeConversion) {
              flattenedIO[metaData.fieldMapping][parentIndex][parentRowFieldKey] = this.commonUtilty.UIDOtoServerDODate(parentRow[parentRowFieldKey])
            }
            else if (fieldKeyWiseParentRowMetaData[parentRowFieldKey].fieldType == 'TIME' && !fieldKeyWiseParentRowMetaData[parentRowFieldKey].ignoreDateTimeConversion) {
              flattenedIO[metaData.fieldMapping][parentIndex][parentRowFieldKey] = this.commonUtilty.UIDOtoServerDOsetTime(parentRow[parentRowFieldKey])
            }
            else if (fieldKeyWiseParentRowMetaData[parentRowFieldKey].fieldType == 'COMBO') {
              if (fieldKeyWiseParentRowMetaData[parentRowFieldKey] && fieldKeyWiseParentRowMetaData[parentRowFieldKey].comboMode == 'multiple') {
                if (fieldKeyWiseParentRowMetaData[parentRowFieldKey].comboBindingType == 'CSV')
                  flattenedIO[metaData.fieldMapping][parentIndex][parentRowFieldKey] = this.commonUtilty.convertArrayToCSV(parentRow[parentRowFieldKey])
              }
            }
            else if (fieldKeyWiseParentRowMetaData[parentRowFieldKey].fieldType == 'FORMARRAY') {
              if (this.commonUtilty.isArrayIterable(fieldKeyWiseParentRowMetaData[parentRowFieldKey]['childGridMetaData'])) {
                flattenedIO[metaData.fieldMapping][parentIndex][parentRowFieldKey].forEach((childRow, childIndex) => {
                  for (const childRowFieldKey in childRow) {
                    if (fieldKeyWiseChildRowMetaData[childRowFieldKey]) {
                      if (fieldKeyWiseChildRowMetaData[childRowFieldKey].fieldType == 'DATE' && !fieldKeyWiseChildRowMetaData[childRowFieldKey].fieldType.ignoreDateTimeConversion) {
                        flattenedIO[metaData.fieldMapping][parentIndex][parentRowFieldKey][childIndex][childRowFieldKey] = this.commonUtilty.UIDOtoServerDODate(childRow[childRowFieldKey])
                      }
                      else if (fieldKeyWiseChildRowMetaData[childRowFieldKey].fieldType == 'TIME' && !fieldKeyWiseChildRowMetaData[childRowFieldKey].fieldType.ignoreDateTimeConversion) {
                        flattenedIO[metaData.fieldMapping][parentIndex][parentRowFieldKey][childIndex][childRowFieldKey] = this.commonUtilty.UIDOtoServerDOsetTime(childRow[childRowFieldKey])
                      }
                      else if (fieldKeyWiseChildRowMetaData[childRowFieldKey].fieldType == 'COMBO') {
                        if (fieldKeyWiseChildRowMetaData[childRowFieldKey] && fieldKeyWiseChildRowMetaData[childRowFieldKey].comboMode == 'multiple') {
                          if (fieldKeyWiseChildRowMetaData[childRowFieldKey].comboBindingType == 'CSV')
                            flattenedIO[metaData.fieldMapping][parentIndex][parentRowFieldKey][childIndex][childRowFieldKey] = this.commonUtilty.convertArrayToCSV(childRow[childRowFieldKey])
                        }
                      }
                    }
                  }
                });
              }
            }
          }
        }
      })
    }
    /**
     * Datatype wise manipulations Ends
     */
    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(payload)}`)
    }
    let output = this.commonUtilty.plainUnflattenObject(flattenedIO, this.flatteningSafetyValue, this.maxDepth)
    return output
  }


  ServerToUITransform(payload, metaData) {
    let DO = this.commonUtilty.getDOName(payload);
    let flattenedIO = this.commonUtilty.plainflattenObject(payload, this.flatteningSafetyValue, this.maxDepth)
    let output = [];
    if (payload && payload[DO] && flattenedIO) {
      if (flattenedIO[metaData.fieldMapping]) output = this.commonUtilty.plainUnflattenObject(flattenedIO[metaData.fieldMapping], this.flatteningSafetyValue, this.maxDepth);
    }
    return output;
  }

  //Initializations
  lookupSubjects = this.commonUtilty.initializeLookupList(this.lookupsToBind)
  lookup$ = {}
  modSearchHospital: boolean = false;
  extraExternalParams = [];
  CRITERIALOOKUP = [];

  ngOnInit() {
    const consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px'
    if (environment && !environment.production) {
      console.group(`%c ${this.baseComponentName}-${this._currentComponentName}: Usage detected on ' + ${this.getParentComponentName()}`, `color: white; background-color: orange; padding: 2px 5px; border-radius: 2px`);
      console.log(`%c Current TargetAttributeType Support for: ${this.supportedTargetAttributeTypes.join(', ')} `, consoleStyle)
      console.log(`%cExample , <${this.getCurrentComponentName()} (componentOutput)='doSomethingOnDataReceived()'></${this.getCurrentComponentName()}>`, consoleStyle)
      console.groupEnd();
    }
    this.lookupsToBind = this.extractLookupToBindFromConfig(this.componentMetaData, this.lookupsToBind)
    this.lookup$ = this.commonUtilty.initializeLookupList(this.lookupsToBind);
    // this.lookupBulkCalls();

    //Design Specific Method
    this.padExpansionStatus()

    // Data Specific Method Calls
    this.metaDataManipulations();
    this.initclaimBillsForm(this._inputDataForEdit);
    this.detectChangeAndPropogateData(this.parentGridForm)
    this.subscribeToParentEvent()

    this.OCRprocessBill();
    this.importSelected();

    this.getDoctorSearchCriteriaList();
    this.extraExternalParams = [
      {
        "paramName": "",
        "paramValue": ""
      }
    ];
  }

  /* Dropdown and Table Items */
  items = [
    { name: 'OPD Charges', amount: '969,500.00', duplicate: true, checked: true },
    { name: 'CSSD', amount: '19,923.00', duplicate: true, checked: true },
    { name: 'Registration and Admission Fee', amount: '', duplicate: true, checked: true },
    { name: 'Doctor Fees', amount: '266,000.00', duplicate: false, checked: true },
    { name: 'E.C.G', amount: '3,000.00', duplicate: false, checked: true },
    { name: 'Echocardiography', amount: '15,000.00', duplicate: false, checked: true },
    { name: 'Endoscopy', amount: '5,753.00', duplicate: false, checked: true },
    { name: 'Medical Supply', amount: '3,818.26.00', duplicate: false, checked: true },
    { name: 'Theatre Charges', amount: '9,926.56', duplicate: false, checked: false },
    { name: '--', amount: '99,650.00', duplicate: false, checked: false },
    { name: 'Pharmacy', amount: '426,995.19', duplicate: false, checked: false },
    { name: 'Physiotherapy', amount: '426,995.19', duplicate: false, checked: false },
    { name: 'Radiology', amount: '42,310.00', duplicate: false, checked: false },
  ];
  bills = [];
  private metaDataManipulations() {
    this.masterConfig.parentRowFormMetaData = this.commonUtilty.sortDateObject('sortOrder', this.masterConfig.parentRowFormMetaData, 'asc');
    let filteredParentRows = this.masterConfig.parentRowFormMetaData.filter(parentRow => parentRow.fieldType == 'FORMARRAY');
    if (filteredParentRows.length < 2) {
      this.masterConfig['parentRowFormMetaDataMap'] = this.commonUtilty.convertArrayToMap(filteredParentRows, 'fieldType') || {};
      if (this.masterConfig['parentRowFormMetaDataMap'] && this.masterConfig['parentRowFormMetaDataMap']['FORMARRAY'] && this.masterConfig['parentRowFormMetaDataMap']['FORMARRAY']['childGridMetaData']) {
        this.masterConfig['parentRowFormMetaDataMap']['FORMARRAY']['childGridMetaData'] = this.commonUtilty.sortDateObject('sortOrder', this.masterConfig['parentRowFormMetaDataMap']['FORMARRAY']['childGridMetaData'], 'asc');
      }
    }
    else {
      console.error('Two FORMARRAYs found', filteredParentRows);
      throw `In ${this.getCurrentComponentName()}, the parentRowFormMetaData cannot have more than 1 fieldType as FORMARRAY`;
    }
  }

  private lookupBulkCalls() {
    Object.keys(this.lookupSubjects).forEach(key => this.lookup$[key] = []);
    this.lookupSubjects = this.commonUtilty.initializeLookupList(this.lookupsToBind);
    for (const key in this.lookupSubjects) {
      this.lookupSubjects[key].subscribe(resp => {
        if (resp && Array.isArray(resp))
          this.lookup$[key] = this.commonUtilty.deepCopy(resp);
      });
    }
  }

  spellCheck(phrase) {
    return this.commonUtilty.spellCheck(phrase)
  }

  extractLookupToBindFromConfig(config, lookupsToBind) {
    if (this.commonUtilty.isArrayIterable(config.parentRowFormMetaData) && Array.isArray(lookupsToBind)) {
      config.parentRowFormMetaData.forEach(parentRow => {
        lookupsToBind = this.commonUtilty.uniquePushInArray(lookupsToBind, parentRow.lookupCd)
        if (parentRow.isChildGrid && this.commonUtilty.isArrayIterable(parentRow.childGridMetaData)) {
          parentRow.childGridMetaData.forEach(childRow => {
            lookupsToBind = this.commonUtilty.uniquePushInArray(lookupsToBind, childRow.lookupCd)
          });
        }
      });
    }

    return lookupsToBind
  }

  padExpansionStatus() {
    for (let index = 0; index < 100; index++) {
      if (index == 0) {
        this.bills.push(true)
      }
      else {
        this.bills.push(false)
      }
    }
  }
  bills_child = [];

  /* IMAGES (DUMMY CODE --- MUST RECODE FOR PRODUCTION) */
  fileList = [
    {
      uid: '1',
      name: 'billA982.png',
      status: 'done',
      url: "/assets/images/demo/hospital-bill-sample.jpg",
    },
    {
      uid: '2',
      name: 'bill202F982.png',
      status: 'done',
      url: "/assets/images/demo/hospital-bill-sample-2.jpg",
    },
  ];
  handlePreview = () => {
    /* CHECK ng_zorro documentation for this code */
    /* Make current image show in preview img src */
    this.toggleImage(); // dummy
    this.msg.success("Selected bill loaded into preview");
  };
  /* END IMAGES */

  /**
   * Form Manipulations
   */
  parentGridForm: FormGroup;
  initclaimBillsForm(data?) {
    let output = data || []
    this.parentGridForm = this.fb.group({
      [this.masterConfig.parentFormArray]: this.fb.array([])
    });
    this.initilizeClaimBillFormWithData(output)
  }

  initilizeClaimBillFormWithData(data) {
    let output = data && (Array.isArray(data) && data.length == 0) ? [{}] : data
    if (this.commonUtilty.isArrayIterable(output)) {
      output.forEach(bill => {
        this.addRow(bill);
      });
    }
  }

  modSearchRemarkCode: boolean = false;
  // isRemarkCodeSelected: boolean = false;
  // remarkCodeIndex = null;

  openSearchRemarkCodeModal(remarkCodeIndex) {
    // this.remarkCodeFetchedFromServer = [];
    this.modSearchRemarkCode = true
    // this.remarkCodeIndex = remarkCodeIndex
    // this.isRemarkCodeSelected = false;
  }

  fetchSearchResult(event){
    console.log(event);
  }

  getDoctorSearchCriteriaList() {
    this.metadataService.fetchAPIMetaData('searchDoctor').subscribe(jsonResp => {
      if (jsonResp && Array.isArray(jsonResp)) {
        jsonResp.forEach(criteria => {
          let searchCriteriaDO = new SearchAPIMetaDataDO();
          searchCriteriaDO.key = criteria.attributeName;
          searchCriteriaDO.keyDescription = criteria.description;
          searchCriteriaDO.valueInputType = criteria.attributeDataTypeCd;
          searchCriteriaDO.lookupName = criteria.attributeLookupCd;
          searchCriteriaDO.lookup = [];
          searchCriteriaDO.enable = true;
          searchCriteriaDO.isMandatory = criteria.mandatoryFl == 'YES' ? true : false;
          this.CRITERIALOOKUP.push(searchCriteriaDO)
        });
      }
    })
  }


  initParentRowForm(metaData, FormName, data?, parentIndex?): FormGroup {
    let payload = data || {}
    if (this.masterConfig['parentRowFormMetaDataMap']['FORMARRAY'] && !payload[this.masterConfig['parentRowFormMetaDataMap']['FORMARRAY'].fieldKey]) {
      payload[this.masterConfig['parentRowFormMetaDataMap']['FORMARRAY'].fieldKey] = [{}]
    }
    let formObject = this.formFactory(metaData, FormName, payload, parentIndex)
    if (parentIndex) {
      let indexControl = this.validationUtilService.setValidationsForFormControl('index', this.FORMNAME, parentIndex)
      formObject.addControl('index', indexControl)
    }
    return formObject
  }

  addRow(data?) {
    let dataForEdit = data || {}
    const control = <FormArray>this.parentGridForm.get(this.masterConfig.parentFormArray);
    control.push(this.initParentRowForm(this.masterConfig.parentRowFormMetaData, this.FORMNAME, dataForEdit, control.value.length));
  }

  addChildRow(parentIndex, data?) {
    let dataForEdit = data || {}
    const parentControlList = <FormArray>this.parentGridForm.get(this.masterConfig.parentFormArray);
    const parentControl = <FormControl>parentControlList.controls[parentIndex]
    const childControlList = <FormArray>parentControl.get(this.masterConfig['parentRowFormMetaDataMap']['FORMARRAY'].fieldKey)
    childControlList.push(this.initParentRowForm(this.masterConfig['parentRowFormMetaDataMap']['FORMARRAY']['childGridMetaData'], this.FORMNAME, dataForEdit, childControlList.value.length));
  }

  removeRow(index: number) {
    const control = <FormArray>this.parentGridForm.get(this.masterConfig.parentFormArray);
    let removeItem = this.parentGridForm.value[this.masterConfig.parentFormArray][index]

    if (this.commonUtilty.isArrayIterable(this._inputDataForEdit) && removeItem) {
      this._inputDataForEdit.forEach((e, i) => {
        if (e.id == removeItem.id) {
          this._inputDataForEdit.splice(i, 0)
        }
      });
    }

    control.removeAt(index);
  }

  lookupValueListMap = {}
  fieldDataChangeHandler(fieldMetaData, fieldKey, formData, parentIndex, childIndex?, isInitCall?) {
    let customHooks = fieldMetaData ? fieldMetaData.customHooks : null
    if (this.commonUtilty.isArrayIterable(customHooks)) {
      let listOfObservables = []
      customHooks.forEach(rule => {
        let serviceCall = this.customHookService[rule.methodName].bind(this)
        let parameterValues = []
        if (this.commonUtilty.isArrayIterable(rule.methodParameters) && formData)
          rule.methodParameters.forEach(parameter => {
            if (parameter.includes('$parent-')) {
              let actualParameterKey = parameter.split('-').slice(-1).pop()
              parameterValues.push(this.getValueOnParentRow(parentIndex, actualParameterKey))
            }
            else
              parameterValues.push(formData[parameter])
          });
        else {
          console.warn(`Either methodParameters or form is empty`, customHooks, formData)
        }
        serviceCall(...parameterValues).subscribe(resp => {
          if (resp) {
            let flattendResp = this.commonUtilty.plainflattenObject(resp)
            let valueToExtract
            if (rule.extractAttributeMapping)
              valueToExtract = flattendResp[rule.extractAttributeMapping]
            else
              valueToExtract = this.commonUtilty.deepCopy(resp)
            if (Array.isArray(valueToExtract)) {
              valueToExtract.forEach((v, i) => {
                valueToExtract[i]['lookupKey'] = v[rule.lookupKeyVariable]
                valueToExtract[i]['lookupValue'] = v[rule.lookupValueVariable]
              })
            }

            this.targetActionEvaluator(rule, parentIndex, childIndex, valueToExtract, isInitCall);

          }
          else {

          }
        });

      });
    }
    else {
      if (!environment.production && fieldMetaData && !fieldMetaData.customHooks && fieldMetaData.fieldRules)
        this.msg.error(`Configuration Error: 'fieldRules' attribute is now called 'customHooks' on ${this.baseComponentName}`)
    }
  }


  private targetActionEvaluator(rule: any, parentIndex: any, childIndex: any, valueToExtract: any, isInitCall: any) {
    switch (rule.targetAttributeType) {
      case "replaceLookupValueList":
        this.lookupValueListMap[`${rule.targetFieldKey}-${parentIndex}${childIndex != 0 && !childIndex ? '' : childIndex}`] = this.commonUtilty.deepCopy(valueToExtract);
        this.resetParentOrChildField(isInitCall, parentIndex, childIndex, rule.targetFieldKey);
        break;
      case "pushLookupValueList":
        this.lookupValueListMap[`${rule.targetFieldKey}-${parentIndex}${childIndex != 0 && !childIndex ? '' : childIndex}`] = this.commonUtilty.uniquePushInArray(this.lookupValueListMap[`${rule.targetFieldKey}-${parentIndex}${childIndex}`], 'lookupKey');
        break;
      case "value":
        if (parentIndex && childIndex) {
          this.setValueOnChildRow(parentIndex, childIndex, rule.targetFieldKey, valueToExtract);
        }
        else {
          this.setValueOnParentRow(parentIndex, rule.targetFieldKey, valueToExtract);
        }
        break;
      case "metaDataAttribute": {
        //For Child Row
        if (typeof parentIndex === 'number' && typeof childIndex === 'number') {
          //To Set Multiple attributes on config, this can be used.
          if (this.commonUtilty.testJSON(JSON.stringify(valueToExtract)))
            this.masterConfig['parentRowFormMetaDataMap']['FORMARRAY']['childGridMetaData'][childIndex] = Object.assign({}, this.masterConfig['parentRowFormMetaDataMap']['FORMARRAY']['childGridMetaData'][childIndex], valueToExtract)
          //To set one attribute on config 
          else
            this.masterConfig['parentRowFormMetaDataMap']['FORMARRAY']['childGridMetaData'][childIndex][rule.targetAttribute] = valueToExtract;
        }
        //For Parent Row
        else {
          //To Set Multiple attributes on config, this can be used.
          if (this.commonUtilty.testJSON(valueToExtract))
            this.masterConfig.parentRowFormMetaData[parentIndex] = Object.assign({}, this.masterConfig.parentRowFormMetaData[parentIndex], valueToExtract)
          //To set one attribute on config 
          else
            this.masterConfig.parentRowFormMetaData[parentIndex][rule.targetAttribute] = valueToExtract;
        }
      }
        break;
      default:
        if (!this.environment.production)
          this.msg.error(`Configuration Error: Unsupported targetAttributeType - ${rule.targetAttributeType} on ${this._currentComponentName} config`)
        break;
    }
  }

  private resetParentOrChildField(isInitCall: any, parentIndex: any, childIndex: any, targetFieldKey: any) {
    try {
      if (!isInitCall) {
        if (typeof parentIndex === 'number' && typeof childIndex === 'number') {
          this.resetValueOnChildRow(parentIndex, childIndex, targetFieldKey);
        }
        else if (typeof parentIndex === 'number' && !(typeof childIndex === 'number')) {
          this.resetValueOnAllChildRow(parentIndex, targetFieldKey);
        }
        else {
          this.resetValueOnParentRow(parentIndex, targetFieldKey);
        }
      }
    }
    catch {
      console.warn(`Minor issue on form Detected`)
    }
  }

  removeChildRow(parentIndex, index: number) {
    const parentControlList = <FormArray>this.parentGridForm.get(this.masterConfig.parentFormArray);
    const parentControl = <FormControl>parentControlList.controls[parentIndex]
    const childControlList = <FormArray>parentControl.get(this.masterConfig['parentRowFormMetaDataMap']['FORMARRAY'].fieldKey)
    let removeItem = <FormControl>childControlList.value[index]

    if (this.commonUtilty.isArrayIterable(this._inputDataForEdit) && removeItem.value) {
      this._inputDataForEdit.forEach((e, i) => {
        if (e.id == parentControl.value.id) {
          if (this.commonUtilty.isArrayIterable(e[this.masterConfig['parentRowFormMetaDataMap']['FORMARRAY'].fieldKey])) {
            e[this.masterConfig['parentRowFormMetaDataMap']['FORMARRAY'].fieldKey].forEach((billBreakupItem, i2) => {
              if (billBreakupItem.id == removeItem.value.id)
                this._inputDataForEdit[i][this.masterConfig['parentRowFormMetaDataMap']['FORMARRAY'].fieldKey].splice(i2, 0)
            });
          }

        }
      });
    }

    childControlList.removeAt(index);
  }

  setValueOnChildRow(parentIndex, childIndex: number, fieldKey, fieldValue) {
    try {
      const parentControlList = <FormArray>this.parentGridForm.get(this.masterConfig.parentFormArray);
      const parentControl = <FormControl>parentControlList.controls[parentIndex]
      const childControlList = <FormArray>parentControl.get(this.masterConfig['parentRowFormMetaDataMap']['FORMARRAY'].fieldKey)
      let controlToUpdate = <FormControl>childControlList.controls[childIndex]['controls'][fieldKey]

      controlToUpdate.setValue(fieldValue)
    }
    catch {
      console.warn(`Minor issue on form Detected`)
    }
  }

  getValueOnChildRow(parentIndex, childIndex: number, fieldKey) {
    try {
      const parentControlList = <FormArray>this.parentGridForm.get(this.masterConfig.parentFormArray);
      const parentControl = <FormControl>parentControlList.controls[parentIndex]
      const childControlList = <FormArray>parentControl.get(this.masterConfig['parentRowFormMetaDataMap']['FORMARRAY'].fieldKey)
      let controlToUpdate = <FormControl>childControlList.controls[childIndex]['controls'][fieldKey]
      return controlToUpdate.value[fieldKey]
    }
    catch {
      console.warn(`Minor issue on form Detected`)
    }
  }

  setValueOnParentRow(parentIndex, fieldKey, fieldValue) {
    try {
      const parentControlList = <FormArray>this.parentGridForm.get(this.masterConfig.parentFormArray);
      const parentControl = <FormControl>parentControlList.controls[parentIndex]
      parentControl.setValue(fieldValue)
    }
    catch {
      console.warn(`Minor issue on form Detected`)
    }
  }

  getValueOnParentRow(parentIndex, fieldKey) {
    try {
      const parentControlList = <FormArray>this.parentGridForm.get(this.masterConfig.parentFormArray);
      const parentControl = <FormControl>parentControlList.controls[parentIndex]
      return parentControl.value[fieldKey]
    }
    catch {
      console.warn(`Minor issue on form Detected`)
    }
  }

  resetValueOnParentRow(parentIndex, fieldKey) {
    try {
      const parentControlList = <FormArray>this.parentGridForm.get(this.masterConfig.parentFormArray);
      const parentControl = <FormControl>parentControlList.controls[parentIndex]['controls'][fieldKey]
      return parentControl.reset()
    }
    catch {
      console.warn(`Minor issue on form Detected`)
    }
  }

  resetValueOnChildRow(parentIndex, childIndex: number, fieldKey) {
    try {
      const parentControlList = <FormArray>this.parentGridForm.get(this.masterConfig.parentFormArray);
      const parentControl = <FormControl>parentControlList.controls[parentIndex]
      const childControlList = <FormArray>parentControl.get(this.masterConfig['parentRowFormMetaDataMap']['FORMARRAY'].fieldKey)
      let controlToUpdate = <FormControl>childControlList.controls[childIndex]['controls'][fieldKey]

      controlToUpdate.reset()
    }
    catch {
      console.warn(`Minor issue on form Detected`)
    }
  }

  resetValueOnAllChildRow(parentIndex, fieldKey) {
    try {
      const parentControlList = <FormArray>this.parentGridForm.get(this.masterConfig.parentFormArray);
      const parentControl = <FormControl>parentControlList.controls[parentIndex]
      const childControlList = <FormArray>parentControl.get(this.masterConfig['parentRowFormMetaDataMap']['FORMARRAY'].fieldKey)
      let extractedFieldKey = fieldKey.substring(7);  //$child-serviceCd
      childControlList.controls.forEach(control => {
        let controlToUpdate = control['controls'][extractedFieldKey]
        controlToUpdate.reset()
      })
    }
    catch {
      console.warn(`Minor issue on form Detected`)
    }
  }

  validateOutput(o, formMetaData): ValidationOutput {
    this.commonUtilty.markAllFieldDirty(o);

    let validationOutput: ValidationOutput = {
      isInvalid: false,
      errorDOs: []
    }
    validationOutput.errorDOs = this.checkInvalidAndEmptyFields(o, this.getCurrentComponentName(), formMetaData)

    //If ErrorDOs Array has elements then it is iterable which means it's invalid
    validationOutput.isInvalid = this.commonUtilty.isArrayIterable(validationOutput.errorDOs);

    return validationOutput
  }

  checkEmptyRows(Form) {
    let parentDataList = []
    if (Form) {
      parentDataList = Form.value[this.masterConfig.parentFormArray]
      if (Array.isArray(parentDataList)) {
        parentDataList.forEach((parentDataItem, parentIndex) => {
          let isParentDataItemValid = false
          let childFormArray = this.masterConfig['parentRowFormMetaDataMap']['FORMARRAY']
          for (const key in parentDataItem) {
            let isChildItemValid = false
            if (childFormArray && key == childFormArray.fieldKey && parentDataItem[key] && Array.isArray(parentDataItem[key])) {
              parentDataItem[key].forEach((billitem, billItemIndex) => {
                for (const key in billitem) {
                  if (billitem[key]) {
                    isChildItemValid = true
                  }
                }
                if (!isChildItemValid) {
                  parentDataList[parentIndex][this.masterConfig['parentRowFormMetaDataMap']['FORMARRAY'].fieldKey].splice(billItemIndex, 1)
                }
              });
            }
            if (parentDataItem[key]) {
              isParentDataItemValid = true
            }
          }

          if (!isParentDataItemValid) {
            parentDataList.splice(parentIndex, 1)
          }
        });
      }
    }
    return parentDataList
  }

  @Input()
  ignoreValidationFields = {
    "preAuthRegistration": [],
    "claimRegistration": [],
  }
  public checkInvalidAndEmptyFields(form: FormGroup, componentName, formMetaData) {
    let invalidFields = [];
    let FormFieldNameMap = this.commonUtilty.convertArrayToMap(formMetaData, 'fieldKey')
    if (form && !form.valid) {
      for (const i in form.controls) {

        let controlName = this.commonUtilty.getControlName(form.controls[i])
        let validationErrorList = this.validationUtilService.getUIErrorList(form.get(controlName), this.FORMNAME)
        if (form.controls[i].status === 'INVALID') {
          validationErrorList.forEach(validationError => {
            let errorDO = new ErrorDO();
            errorDO.errorMsg = validationError.errorMessage;
            errorDO.validationLevel = validationError.validationLevel
            errorDO.fieldName = controlName;
            errorDO.fieldNameDescription = FormFieldNameMap[controlName].fieldName
            errorDO.componentName = componentName;
            invalidFields.push(errorDO)
          })
        }
      }
    }
    if (this.ignoreValidationFields[this.transactionState] && this.commonUtilty.isArrayIterable(this.ignoreValidationFields[this.transactionState])) {
      let tempArray = [];
      invalidFields.forEach(invalidField => {
        if (!this.ignoreValidationFields[this.transactionState].includes(invalidField.fieldName))
          tempArray.push(invalidField);
      });
      invalidFields = tempArray;
    }
    return invalidFields;
  }

  detectChangeAndPropogateData(form) {
    if (form) {
      let firstOutput = this.commonUtilty.deepCopy(form.value)
      this.propagateChange(firstOutput)
      form.valueChanges.subscribe(e => {
        let formData = form.value || []
        if (this.commonUtilty.isArrayIterable(formData[this.masterConfig.parentFormArray])) {
          this.propagateChange(formData)
        }
        else {
          this.propagateChange(this._inputDataForEdit)
        }
      })
    }
  }

  isRequired(fieldName, formName?) {
    let nameOfForm = null
    if (formName) {
      nameOfForm = formName
    }
    else {
      nameOfForm = this.FORMNAME
    }
    let returnObj = this.validationUtilService.isRequired(fieldName, nameOfForm)
    return returnObj
  }

  formFactory(metaData, FormName, dataObject = {}, parentIndex?, childIndex?) {
    let formDataOuput = {}
    if (metaData && Array.isArray(metaData)) {
      metaData.forEach(field => {
        let intialValue
        if (field.fieldType == 'DATE') {
          intialValue = this.commonUtilty.serverDOtoUIDODate(dataObject[field.fieldKey]) || this.commonUtilty.serverDOtoUIDODate(field.defaultValue)
        }
        else if (field.fieldType == 'TIME') {
          intialValue = this.commonUtilty.serverDOtoUIDOsetTime(dataObject[field.fieldKey]) || this.commonUtilty.serverDOtoUIDOsetTime(field.defaultValue)
        }
        else if (field.fieldType == 'COMBO' && field.comboMode == 'multiple') {
          intialValue = this.commonUtilty.convertCSVToArray(dataObject[field.fieldKey]) || this.commonUtilty.convertCSVToArray(field.defaultValue)
        }
        else if (field.fieldType == 'FORMARRAY') {
          let outputFormList = []
          let childData = dataObject[field.fieldKey]
          if (this.commonUtilty.isArrayIterable(childData)) {
            childData.forEach((childRowData, rowChildIndex) => {
              this.childRowDependencyAPICalls(childRowData)
              let form = this.formFactory(field.childGridMetaData, field.childFormName, childRowData, parentIndex, rowChildIndex)
              let indexControl = this.validationUtilService.setValidationsForFormControl('index', field.childFormName, outputFormList.length)
              if (form) {
                form.addControl('index', indexControl)
                outputFormList.push(form)
              }
              else {
                console.error("Child Form got invalid data - ", field)
              }
            });
          }
          intialValue = this.fb.array(outputFormList)
        }
        else {
          intialValue = dataObject[field.fieldKey] || field.defaultValue
        }

        if (field.fieldType == 'FORMARRAY') {
          formDataOuput[field.fieldKey] = intialValue
        }
        else {
          formDataOuput[field.fieldKey] = this.validationUtilService.setValidationsForFormControl(
            field.fieldKey, FormName, intialValue)
        }

        let isInitCall = true

        this.fieldDataChangeHandler(field, field.fieldKey, dataObject, parentIndex, childIndex, isInitCall)
      })
    }

    let output = this.fb.group(formDataOuput)

    return output
  }

  childRowDependencyAPICalls(childRowData) {

  }

  parentRowDependecyAPICalls(parentRowData) {

  }

  modalBill: boolean = false;
  billImage = this.fileList[0].url;

  /* OCR PROCESS IMAGE */
  /* DEMO ONLY -- WRITE FN TO PROCESS OCR + WRITE CUSTOM LOGIC FOR NON-OVERWRITING TABLE DATA FIELDS */
  processingOCR: boolean = true;
  OCRprocessBill() {
    this.processingOCR = true;
    setTimeout(() => this.processingOCR = false, 1500);
  }
  toggleImage() {
    this.billImage == this.fileList[0].url ?
      this.billImage = this.fileList[1].url : this.fileList[0].url;
  }

  importSelected() {
    this.modalBill = false;
    // this.bills_child = Object.create(this.items.filter(i => i.checked == true));
    // this.bills[0].expanded = true;
  }



}
